<template>
  <v-hover v-slot:default="{ hover }">
    <div class="todo">
      <div
        v-if="task"
        class="task-item-wrapper layout   nowrap my-1"
        :style="statusStyle"
        @mouseenter="makeActive(task)"
        @click.stop="isActive = !isActive"
        @mouseleave="active = false"
      >
        <div v-show="!withoutStatus" class="status align-start pr-1">
          <v-btn small :disabled="updateMode" :loading="isLoading" icon @click.native="changeStatus(task)">
            <v-icon color="primary">
              {{ statusIcon }}
            </v-icon>
          </v-btn>
        </div>
        <div :class="`content ${updateMode ? 'block' : 'd-inline-flex'} align-center pa-0`">
          <div class="content-text">
            <textarea-autosize
              v-if="updateMode"
              id="contentInput"
              ref="contentInput"
              v-model="task.data.text"
              class="align-self-center update-input pa-1"
            />
            <span v-else class="text-break">{{ task.data.text }}</span>
          </div>
          <v-divider v-if="isScrolled && isActive" />
          <div v-if="updateMode || !isActive" class="layout nowrap justify-center align-center">
            <v-btn
              v-if="updateMode"
              :loading="isLoading"
              class="save-block"
              depressed
              color="primary"
              small
              @click.stop="updateTask(task)"
            >
              Save
            </v-btn>
            <v-btn
              v-if="updateMode"
              :loading="isLoading"
              depressed
              color="secondary"
              small
              @click.stop="abortUpdate(task)"
            >
              Abort
            </v-btn>

            <!-- <v-btn @click="isActive = true;" icon>
              <v-icon>{{ icons.arrows.down }}</v-icon>
            </v-btn>-->
          </div>
        </div>
        <div class="actions align-self-start justify-self-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn small icon @click.stop="" v-on.stop="on">
                <v-icon>{{ icons.more }}</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-if="authService.isManager"
                @click.stop="
                  updateMode = true;
                  isActive = false;
                "
              >
                <v-list-item-title>Update</v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="deleteTask(task)">
                <v-list-item-title color="red">
                  Delete Task
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-show="task.status.step !== 'backlog' || task.status.step !== 'to_do'"
                @click.stop="changeStatus(task, true)"
              >
                <v-list-item-title color="red">
                  Revert Status
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-expand-transition>
        <div v-show="isActive && !updateMode && !inEditor" class="meta px-2 text--muted">
          <!-- <div class="first-line">{{task.data.author}}</div> -->
          <div class="comment-wrapper mt-0 mb-2">
            <div :id="`comment-wrapper-${task._id}`" class="wrapper-main">
              <v-fade-transition group>
                <comment-item v-for="comment in task.data.comments" :key="comment.id" :comment="comment" />
              </v-fade-transition>
            </div>
            <div class="make-comment layout   nowrap align-center mt-2">
              <div class="author">
                <v-avatar size="25px" color="primary">
                  <span class="white--text">ME</span>
                </v-avatar>
              </div>
              <div class="input ml-2" @click.stop="">
                <div class="input-wrapper align-center px-3 py-1 comment-input layout   nowrap">
                  <textarea-autosize
                    v-model="newComment.text"
                    rows="1"
                    :min-height="22"
                    class="align-self-center input"
                    placeholder="Make a comment"
                  />
                  <v-spacer />
                  <v-btn
                    :disabled="!newComment.text || newComment.text === ''"
                    :loading="isLoading"
                    x-small
                    color="primary"
                    icon
                    @click="makeComment(task)"
                  >
                    <v-icon small>
                      {{ icons.todos.comments.send }}
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <!-- <div class="layout nowrap align-center justify-center mt-2">
                  <v-btn @click="isActive = false;" icon>
                    <v-icon>{{ icons.arrows.top }}</v-icon>
                  </v-btn>
            </div>-->
          </div>
          <div class="sharing-section px-0 py-1">
            <sharing :intitial-sharing="task.sharing" />
          </div>
        </div>
      </v-expand-transition>
    </div>
  </v-hover>
</template>

<script>
import icons from '@/mixins/icons';
import auth from '@/mixins/AuthorizationMixin';
import TodoListCommentVue from './TodoListComment.vue';
import {
  UPDATE_TASK,
  TASK_STATUS,
  SET_TASK_ACTIVE,
  CAN_CHANGE_TASK_STATUS,
  CAN_CHANGE_TASK_STATUS_REVERT
} from '../../config/constants';
import uuid from 'uuid';
import { mapState } from 'vuex';
import AuthorizationService from '../../services/AuthorizationService';
import SharingComponentVue from './SharingComponent.vue';
import CoreInputVue from '../core/inputs/CoreInput.vue';
export default {
  name: 'TodoListItem',
  components: {
    commentItem: TodoListCommentVue,
    sharing: SharingComponentVue,
    coreInput: CoreInputVue
  },
  mixins: [icons],
  props: {
    task: Object,
    createOne: Boolean,
    inEditor: Boolean,
    withoutStatus: Boolean
  },
  data() {
    return {
      authService: new AuthorizationService(),
      isLoading: false,
      updateMode: false,
      isScrolled: false,
      isActive: false,
      newComment: {
        text: ''
      },
      fakeData: [
        {
          author: 'ole.zierau@fishermanhealth.com',
          text: 'Test'
        }
      ]
    };
  },
  watch: {
    isActive: function(o, p) {
      if (o) {
        this.checkOverflow();
      }
    }
  },
  mounted() {
    if (this.createdTasks.includes(this.task._id) && this.inEditor) {
      this.updateMode = true;
    }
  },
  methods: {
    async abortUpdate(task) {
      if (this.createdTasks.includes(task._id)) {
        await this.deleteTask(task);
      }
      this.updateMode = false;
    },
    async updateTask(task) {
      await this.update(task);
      await this.makeComment(task, `${this.$store.state.user.me.name} updated the task description`, 'info');
      this.updateMode = false;
    },
    async update(task) {
      try {
        this.isLoading = true;
        this.$store.commit('tasks/removeFromNewlyCreated', task._id);
        return await this.$store.dispatch(UPDATE_TASK, task);
      } catch (error) {
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    deleteTask(task) {
      this.$store.dispatch('tasks/removeTask', task);
    },
    makeActive(task) {
      // this.isActive = true;
      this.$store.commit(SET_TASK_ACTIVE, task);
    },
    async changeStatus(task, reset) {
      const status = task.status.step;
      if (!task.status.history) {
        task.status['history'] = [];
      }
      const history = task.status.history.push({
        status,
        user: task.status.user,
        changedAt: task.status.changedAt
      });
      let updateObject = {};
      const statusArray = Object.values(TASK_STATUS);
      const statusIndex = statusArray.indexOf(status) || 0;
      const direction = reset ? statusIndex - 1 : statusIndex + 1;
      const nextStatus = statusArray[direction % statusArray.length];
      const roles = new AuthorizationService().getRoles();
      const changeArray = reset ? CAN_CHANGE_TASK_STATUS_REVERT : CAN_CHANGE_TASK_STATUS;
      const canChange = _.intersection(changeArray[nextStatus], roles).length > 0;

      // let nextStatus = null;
      // if (nextStatusIndex === statusArray.length - 1)
      //   nextStatus = statusArray[0];
      // else nextStatus = statusArray[statusIndex + 1];

      // task.status.history =  history.push({
      //   status,
      //   user: task.status.user,
      //   changedAt: task.status.changedAt
      // }) || [
      //   { status, user: task.status.user, changedAt: task.status.changedAt }
      // ];
      if (canChange) {
        task.status.step = nextStatus;
        task.status.user = this.$store.state.user.me._id;

        await this.update(task);
        await this.makeComment(
          task,
          `${this.$store.state.user.me.name} ${reset ? 'reverted' : 'changed'} status to ${nextStatus
            .replace('_', ' ')
            .toUpperCase()}`,
          'info'
        );
      } else {
        this.$store.dispatch(
          'alerts/warning',
          `Not permitted to set task to ${nextStatus.replace('_', ' ').toUpperCase()}.`
        );
      }
    },
    makeComment(task, text, type) {
      if (text !== '' || this.newComment.text !== '') {
        if (!task.data.comments) {
          task.data['comments'] = [];
        }
        task.data.comments.push({
          author: this.$store.state.user.me.name,
          user: this.$store.state.user.me._id,
          text: text || this.newComment.text,
          id: uuid.v4(),
          type: type || 'chat',
          createdAt: Date.now()
        });
        this.update(task);
        this.newComment.text = null;
      }
    },
    checkOverflow(e) {
      const name = `comment-wrapper-${this.task._id}`;
      const element = document.getElementById(name);
      const isScrolled =
        element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
      this.isScrolled = isScrolled;
    }
  },
  computed: {
    ...mapState('tasks', {
      createdTasks: state => state.createdItems
    }),
    statusStyle() {
      if (this.task) {
        switch (this.task.status.step) {
          case 'backlog':
            return {};
          case 'to_do':
            return {};
          case 'needs_approval':
            return {};
          case 'done':
            return {
              opacity: '.6',
              textDecoration: 'line-through'
            };
          default:
            break;
        }
      }
    },
    statusIcon() {
      if (this.task) {
        switch (this.task.status.step) {
          case 'backlog':
            return this.icons.todos.notChecked;
          case 'to_do':
            return this.icons.todos.notChecked;
          case 'needs_approval':
            return this.icons.todos.needsApproval;
          case 'done':
            return this.icons.todos.checked;
          default:
            break;
        }
      }
    }
  }
};
</script>
<style>
.task-item-wrapper:not(:first-child) {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
<style lang="scss" scoped>
.todo {
  // border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.content {
  flex-grow: 1;
}
.input {
  outline: none !important;
}

.content-text {
  font-size: 0.9em;
  text-align: justify;
}
.meta {
  font-size: 0.8em;
  // border-top: 1px solid rgba(0,0,0,.12);
}
.input {
  width: 100%;
}
.save-block {
  flex-grow: 1;
  margin-right: 3px;
}
.comment-input {
  // border: 1px solid rgba(0, 0, 0, 0.12);
  width: 100%;
  border-radius: 23px;
  background-color: #f5f5f5;
}
.wrapper-main {
  overflow-y: scroll;
  max-height: 250px;
  display: flex;
  flex-direction: column-reverse;
  text-decoration: none !important;
}
.update-input {
  border: 1px solid var(--new-blue);
  width: 100%;
  border-radius: 3px;
}
.text-break {
  word-break: break-all;
}
</style>
